import { SpinnerWithLabel } from './SpinnerWithLabel';

export default SpinnerWithLabel;
